export default {
    getTransactionList: (state) => {
        return state.transactionList;
    },
    getTransactionListCount: (state) => {
        return state.transactionListCount;
    },
    getTransactionMainFilter: (state) => {
        return state.transactionFilter.main_filter;
    },
    getTransactionFilterFields: (state) => {
        return state.transactionFilter.fields;
    },
    getSupplementAmount: (state) => {
        return state.supplement_amount;
    },
    getClientBankReceiptFile: (state) => {
        return state.client_bank_receipt_file;
    },
    getBankReceiptFile: (state) => {
        return state.bank_receipt_file;
    },
}
